import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';
import TextField from '@mui/material/TextField';
import { UseMutateFunction } from '@tanstack/react-query';
import { TRACKABLE_EVENTS, trackEventBudget } from 'helpers/trackerHelpers';
import { useSelectSecondaryBudgetAxisSourceTable } from 'routes/BudgetModule/components/BudgetWithProvider/SecondaryBudgetAxisSourceTableContext';

type Props = {
    show: boolean;
    cancel: () => void;
    name: string;
    setName: DispatchState<string>;
    confirm: UseMutateFunction;
    initialName: string;
    exercice: number;
};

const StyTextField = styled(TextField, {
    name: 'StyTextField',
})(() => ({
    marginLeft: '1rem',
    marginRight: '1rem',
    maxWidth: '100%',
}));

export const DraftOperationNameEditModal: React.FC<Props> = ({
    show,
    cancel,
    confirm,
    name,
    setName,
    initialName,
    exercice,
}) => {
    const { t } = useTranslation();
    const sourceTable = useSelectSecondaryBudgetAxisSourceTable();
    return (
        <Dialog open={show}>
            <DialogTitle sx={{ fontSize: '18px', fontWeight: '600' }}>
                {t('createDraftOperation.renameHeaderTitle', {
                    context: sourceTable,
                })}
            </DialogTitle>

            <DialogTitle sx={{ fontSize: '18px', fontWeight: '400' }}>
                {t('createDraftOperation.chooseNameTitle')}
            </DialogTitle>
            <DialogContent sx={{ mb: 1 }}>
                {t('createDraftOperation.chooseNameDescription')}
            </DialogContent>
            <StyTextField
                value={name}
                onChange={(event) => {
                    setName(event.target.value);
                }}
                variant="outlined"
            />
            <DialogActions>
                <Button
                    onClick={() => {
                        setName(initialName);
                        cancel();
                    }}
                >
                    {t('common.close')}
                </Button>
                <Button
                    disabled={name === initialName}
                    onClick={() => {
                        trackEventBudget(
                            TRACKABLE_EVENTS.budget.budgetOverview.operations
                                .draftOperation.confirmRename,
                            {
                                exercice,
                            },
                        );
                        confirm();
                    }}
                >
                    {t('common.confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
